module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"es6-promise"}
// module id = 13
// module chunks = 0 1